import { combineReducers } from 'redux';
import editGallery from './editGallery';

export default combineReducers({ editGallery });
